import { render, staticRenderFns } from "./MessageLabel.vue?vue&type=template&id=2ee625c8&scoped=true&"
import script from "./MessageLabel.vue?vue&type=script&lang=ts&"
export * from "./MessageLabel.vue?vue&type=script&lang=ts&"
import style0 from "./MessageLabel.vue?vue&type=style&index=0&id=2ee625c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee625c8",
  null
  
)

export default component.exports